import { mapper } from '../mapper';
import { mapIncludesFactory } from '../mappers/includes/mapIncludesFactory';

/**
 * Mergea las dependencias en los campos de tipo "include" (solo "include" de momento)
 * /!\ Esta función modifica el view original /!\
 *
 * @param {object} view el json
 * @param {object} dependencies {filename: file} lista de ficheros que pueden ser .view o .in4 de momento
 * @return {object} el view actualizado con sus dependencias
 */

export function mergeIncludes(view, dependencies) {
  if (typeof dependencies === 'object' && Object.keys(dependencies).length) {
    return mapper(view, mapIncludesFactory(dependencies));
  }

  return view;
}
